import { useState } from "react";
import { Copy, Mail, Share2 } from "lucide-react";
import { toast } from "sonner";
import { copyToClipboard } from "../../lib/copyToClipboard";
import { track } from "../../lib/analytics";

export function joinLinkFor(code) {
  return `${window.location.origin}/join/team?code=${encodeURIComponent(code || "")}`;
}

export function defaultInvite(coach, team, link) {
  return `Hi families! I'm Coach ${coach} and I'll be coaching ${team} this season. We'll use ChalkOS for our schedule, changes, and team messages. Join here: ${link}. See you at our first practice!`;
}

const btn = {
  flex: 1, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6,
  padding: "10px 8px", borderRadius: 999, border: "0.5px solid var(--chalk-border)",
  background: "#fff", color: "var(--chalk-board)", fontSize: 13, cursor: "pointer",
};

export default function InviteParentsCard({ coach, team, joinCode, teamId }) {
  const [text, setText] = useState(() => defaultInvite(coach || "", team || "", joinLinkFor(joinCode)));
  const done = (how) => track("invite_shared", { source_screen: how, team_id: teamId || null });

  async function onCopy() {
    if (await copyToClipboard(text)) { toast.success("Message copied."); done("copy"); }
  }
  async function onShare() {
    if (navigator.share) {
      try { await navigator.share({ text }); done("share"); } catch { /* cancelled */ }
    } else onCopy();
  }
  function onEmail() {
    done("email");
    window.location.href = `mailto:?subject=${encodeURIComponent(`Join ${team} on ChalkOS`)}&body=${encodeURIComponent(text)}`;
  }

  return (
    <div data-testid="invite-parents-card" style={{ background: "#fff", border: "0.5px solid var(--chalk-border)", borderRadius: 14, padding: 14 }}>
      <div style={{ fontSize: 15, fontWeight: 600, color: "var(--chalk-board)" }}>Invite your parents</div>
      <div style={{ fontSize: 12, color: "var(--chalk-muted)", margin: "4px 0 10px" }}>Edit it if you like, then send it your usual way.</div>
      <textarea
        data-testid="invite-parents-text" value={text} onChange={(e) => setText(e.target.value)} rows={6}
        style={{ width: "100%", fontSize: 16, lineHeight: 1.45, padding: 10, borderRadius: 10, border: "0.5px solid var(--chalk-border)", resize: "vertical", boxSizing: "border-box" }}
      />
      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
        <button type="button" style={btn} onClick={onCopy} data-testid="invite-copy-btn"><Copy size={14} /> Copy</button>
        <button type="button" style={btn} onClick={onShare} data-testid="invite-share-btn"><Share2 size={14} /> Share</button>
        <button type="button" style={btn} onClick={onEmail} data-testid="invite-email-btn"><Mail size={14} /> Email</button>
      </div>
    </div>
  );
}
